import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class UserActivityStore {
    selectedDate: string = new Date().toString();
    yearSelected: string = new Date().getFullYear().toString();
    monthSelected: string = new Date().getMonth().toString();
    isYearSelctionShow: boolean = false;
    isCalenderShow: boolean = false;
    historySearchString: string = "";
    userActivityHistory = [];
    fromDate: string = new Date().toISOString();
    toDate: string = new Date().toISOString();



    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setSelectedDate(date: string) {
        this.selectedDate = date;
    }
    get getSelectedDate() {
        return this.selectedDate
    }

    //

    setFromDate(date: string) {
        this.fromDate = date;
    }
    get getFromDate() {
        return this.fromDate;
    }

    setToDate(date: string) {
        this.toDate = date;
    }
    get getToDate() {
        return this.toDate;
    }

    //
    setYearSelected(year: string) {
        this.yearSelected = year;
    }
    get getSelectedYear() {
        return this.yearSelected
    }

    setMonthSelected(month: string) {
        this.monthSelected = month;
    }
    get getSelectedMonth() {
        return this.monthSelected
    }


    handleYearSelectionShow = () => {
        this.isYearSelctionShow = !this.isYearSelctionShow;
    }

    get getYearSelection() {
        return this.isYearSelctionShow;
    }

    handleCalendarShow = () => {
        this.isCalenderShow = !this.isCalenderShow;
    }

    get getCalendarShow() {
        return this.isCalenderShow;
    }

    handleSearchString(str: string) {
        this.historySearchString = str;
    }

    setUserActivityHistory = (useractivity: any) => {
        this.userActivityHistory = useractivity;
    }
    get getUserActivityHistory() {
        return this.userActivityHistory;
    }

}